import { render, staticRenderFns } from "./polityka-prywatnosci.vue?vue&type=template&id=34d91af9&scoped=true&"
import script from "./polityka-prywatnosci.vue?vue&type=script&lang=js&"
export * from "./polityka-prywatnosci.vue?vue&type=script&lang=js&"
import style0 from "./polityka-prywatnosci.vue?vue&type=style&index=0&id=34d91af9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d91af9",
  null
  
)

export default component.exports